import React, { useState } from "react";
import "./Contact.css";



const Contact: React.FC = () => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);

  const [loading, setLoading] = useState(false);
const [successMsg, setSuccessMsg] = useState('');
const [errorMsg, setErrorMsg] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // const handleSubmit = (e: React.FormEvent) => {
  //   e.preventDefault();
  //   setSent(true);
  // };
  
//   const handleSubmit = async (e: React.FormEvent) => {
//   e.preventDefault();
//   try {
//     const res = await fetch('https://infotech-backend-v4eo.onrender.com/api/contact', {
//     // const res = await fetch('http://localhost:4000/api/contact', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(form),
//     });
//     if (res.ok) setSent(true);
//   } catch (err) {
//     console.error(err);
//   }
// };
const handleSubmit = async (e: React.FormEvent) => {
  e.preventDefault();

  setLoading(true);
  setSuccessMsg('');
  setErrorMsg('');

  try {
    const res = await fetch(
      // 'https://infotech-backend-v4eo.onrender.com/contact/send',
      'https://ajera-infotech-backend.onrender.com/contact/send',
      // 'http://localhost:4000/contact/send',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(form),
      }
    );

    const result = await res.json();

    if (result.success) {
      setSuccessMsg(
        '✅ Message sent successfully! We will get back to you soon.'
      );

      setForm({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
      });
    } else {
      setErrorMsg(
        result.message || '❌ Failed to send message.'
      );
    }
  } catch (err) {
    setErrorMsg('❌ Server error. Please try again later.');
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="contact-page">
      {/* Hero */}
      <section className="contact-hero">
        <div className="contact-hero__bg" />
        <div className="container">
          <span className="section-label">Get In Touch</span>
          <h1 className="contact-hero__title">Let's start a conversation </h1>
          <p className="contact-hero__sub">
            Have a project in mind? Want to explore our courses? We'd love to hear from you.
            Reach out and we'll respond within 24 hours.
          </p>
        </div>
      </section>

      <section className="contact-body">
        <div className="container">
          <div className="contact-grid">
            {/* ── INFO ── */}
            <div className="contact-info">
              <h2 className="contact-info__title">Contact Details</h2>
              <div className="contact-info__items">
                <div className="contact-info__item">
                  <span className="contact-info__icon">📧</span>
                  <div>
                    <p className="contact-info__label">Email Us</p>
                    <a href="mailto:contact@ajeragroup.com" className="contact-info__val">contact@ajeragroup.com</a>
                  </div>
                </div>
                <div className="contact-info__item">
                  <span className="contact-info__icon">📞</span>
                  <div>
                    <p className="contact-info__label">Call Us</p>
                    <a href="tel:+919751772429" className="contact-info__val">+91 97517 72429</a>
                  </div>
                </div>
                <div className="contact-info__item">
                  <span className="contact-info__icon">📍</span>
                  <div>
                    <p className="contact-info__label">Location</p>
                    <p className="contact-info__val">Tamil Nadu, India</p>
                  </div>
                </div>
                <div className="contact-info__item">
                  <span className="contact-info__icon">⏰</span>
                  <div>
                    <p className="contact-info__label">Business Hours</p>
                    <p className="contact-info__val">Mon–Sat · 9 AM – 7 PM IST</p>
                  </div>
                </div>
              </div>

              {/* Social quick links */}
              <div className="contact-socials">
                <p className="contact-socials__label">Quick Connect</p>
                <div className="contact-socials__row">
                  <a href="https://wa.me/919751772429" target="_blank" rel="noopener noreferrer" className="contact-social contact-social--wa">
                    <span>WA</span> WhatsApp
                  </a>
                  <a href="https://www.instagram.com/ajera_infotech?igsh=MTV1dDE1bTVmbG1ueQ==" target="_blank" rel="noopener noreferrer" className="contact-social contact-social--ig">
                    <span>IG</span> Instagram
                  </a>
                  <a href="https://www.linkedin.com/company/ajera-infotech/" target="_blank" rel="noopener noreferrer" className="contact-social contact-social--li">
                    <span>IN</span> LinkedIn
                  </a>
                </div>
              </div>
            </div>

            {/* ── FORM ── */}
            <div className="contact-form-wrap">
              {sent ? (
                <div className="contact-success">
                  <div className="contact-success__icon">✅</div>
                  <h3>Message Sent!</h3>
                  <p>Thanks for reaching out. We'll get back to you within 24 hours.</p>
                  <button className="btn-primary" onClick={() => { setSent(false); setForm({ name:"", email:"", phone:"", subject:"", message:"" }); }}>
                    Send Another
                  </button>
                </div>
              ) : (
                <form className="contact-form" onSubmit={handleSubmit}>
                  <h2 className="contact-form__title">Send us a message</h2>
                  <div className="contact-form__row">
                    <div className="contact-form__field">
                      <label>Full Name *</label>
                      <input type="text" name="name" placeholder="Your name" value={form.name} onChange={handleChange} required />
                    </div>
                    <div className="contact-form__field">
                      <label>Email *</label>
                      <input type="email" name="email" placeholder="your@email.com" value={form.email} onChange={handleChange} required />
                    </div>
                  </div>
                  <div className="contact-form__row">
                    <div className="contact-form__field">
                      <label>Phone</label>
                      <input type="tel" name="phone" placeholder="+91 99999 99999" value={form.phone} onChange={handleChange} />
                    </div>
                    <div className="contact-form__field">
                      <label>Subject *</label>
                      <select name="subject" value={form.subject} onChange={handleChange} required>
                        <option value="">Select a subject</option>
                        <option>Web Development Project</option>
                        <option>Mobile App Development</option>
                        <option>AI / ML Solutions</option>
                        <option>Cloud & DevOps</option>
                        <option>Cyber Security</option>
                        <option>Course Enquiry</option>
                        <option>Internship Enquiry</option>
                        <option>Career / Jobs</option>
                        <option>General Enquiry</option>
                      </select>
                    </div>
                  </div>
                  <div className="contact-form__field">
                    <label>Message *</label>
                    <textarea name="message" placeholder="Tell us about your project or enquiry..." rows={5} value={form.message} onChange={handleChange} required />
                  </div>
                  {successMsg && (
                    <p className="form-success">{successMsg}</p>
                  )}

                  {errorMsg && (
                    <p className="form-error">{errorMsg}</p>
                  )}
                  {/* <button type="submit" className="btn-primary contact-form__submit">
                    Send Message
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="16" height="16">
                      <path d="M5 12h14M12 5l7 7-7 7" />
                    </svg>
                  </button> */}
                  <button
                    type="submit"
                    className="btn-primary contact-form__submit"
                    disabled={loading}
                  >
                    {loading ? 'Sending...' : 'Send Message'}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
